/* global customElements */
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */

/**
 * Form to test regex expressions
 * 
 */
class RegexTester extends BaseComponent {
	
	static get properties() {
		return {
			expression: {type: String},
			value: {type: String}
		};
	}
	
	constructor() {
		super();
		
		this.expression = '';
		this.value = '';
				
		var regexForm = this;
		setTimeout(function(){
			regexForm.init();
		});		
	}
	
	render() {
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var regexForm = this;
		
		var testerLink = ElementUtil.create({
			tag: 'a',
			style: 'cursor: pointer;',
			innerHTML: 'Regex Expression Tester',
			listeners: {
				click: function() {
					actionShowTestWin();					
				}
			}
		});	
		regexForm.append(testerLink);
		
		var actionShowTestWin = function() {
			
			var testWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Test',
				icon: 'vaadin:input',				
				width: 610,
				height: 300,
				listeners: {
					ready: function () {
						testWin.show();
						
						var messagePanel = ElementUtil.create({
							tag: 'div',
							'class': 'regex-tester-message'
						});
					
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',							
							children: [
								messagePanel,
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'vaadin-text-field',
											name: 'expression',
											label: 'Regular Expression',
											value: regexForm.expression,
											required: true
										},
										{
											tag: 'vaadin-text-field',
											name: 'testValue',
											value: regexForm.value,
											label: 'Test Value'
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:check', ' Test')
													],
													listeners: {
														click: function () {
															
															var data = formPanel.getData();			
															
															var loadMask = formPanel.showLoading('Checking...');
															Service.getApplicationService().testRegex(data).then(function(results){
																loadMask.remove();
																
																messagePanel.classList.remove('regex-tester-error', 'regex-tester-matched', 'regex-tester-unmatched');
																if (results.errorMessage) {
																	messagePanel.classList.add('regex-tester-error');
																	messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close"></vaadin-icon> ' + results.errorMessage + '</b>';
																} else {
																	if (results.matched) {
																		messagePanel.classList.add('regex-tester-matched');
																		messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:check-circle"></vaadin-icon> Matched</b>';																	
																	} else {
																		messagePanel.classList.add('regex-tester-unmatched');
																		messagePanel.innerHTML = '<b><vaadin-icon icon="vaadin:close-circle"></vaadin-icon> Did not matched</b>';																			
																	}
																}
															});
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Close',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															//cancel
															testWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						
						testWin.addToContentElement(formPanel);

					}
				}
			});
			
		};
		
	}
	
	updateValues(expression, value) {
		var regexForm = this;
		
		regexForm.expression = expression;
		regexForm.value = value;		
	}
		
};
customElements.define('dl-regex-tester', RegexTester);



